import { render } from "./TaskTimerButtons.vue?vue&type=template&id=b990e142"
import script from "./TaskTimerButtons.vue?vue&type=script&lang=js"
export * from "./TaskTimerButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__